import React from 'react';
var MenuContext = /*#__PURE__*/React.createContext(null);
export default MenuContext;